import { Component } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { ReportListComponent } from "../../components/reports/report-list/report-list.component";
import { AppFloatingConfigurator } from "src/app/layout/component/app.floatingconfigurator";
import { TicketReportListComponent } from "../../components/reports/ticket-report-list/ticket-report-list.component";

@Component({
  selector: 'app-reports',
  imports: [SharedModule, ReportListComponent, AppFloatingConfigurator, TicketReportListComponent],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {
  reportTabs = [
    { icon: 'pi pi-users', name: 'Leads Report' },
    // { icon: 'pi pi-briefcase', name: 'Deals Report' },
    { icon: 'pi pi-ticket', name: 'Tickets Report' },
    // { icon: 'pi pi-bullhorn', name: 'Campaign Report' },
  ];


  activeTab = 0;

  ngOnInit() {
    const savedTab = localStorage.getItem('activeReportTab');
    if (savedTab) {
      this.activeTab = parseInt(savedTab, 10);
    }
  }

  handleTabClick(index: number) {
    this.activeTab = index;
    localStorage.setItem('activeReportTab', index.toString());
  }

}
